import React, { useState, useEffect } from "react";
import newsData from "./YangilikData";
import {
    FaTimes, FaLightbulb, FaCode, FaLaptopCode,
    FaRocket, FaBrain, FaRobot, FaLock, FaShieldAlt, FaUsers, FaMobileAlt,
    FaPaintBrush, FaDatabase, FaChartBar, FaChartPie, FaServer, FaSearch,
    FaUserCheck, FaUserSecret, FaNetworkWired, FaTools, FaCloud, FaStore,
    FaChartLine, FaMoneyBillWave
} from "react-icons/fa";
import "./YangilikModal.css";

// Icon mapping helper
const iconMap = {
    FaLightbulb: <FaLightbulb />,
    FaCode: <FaCode />,
    FaLaptopCode: <FaLaptopCode />,
    FaRocket: <FaRocket />,
    FaBrain: <FaBrain />,
    FaRobot: <FaRobot />,
    FaLock: <FaLock />,
    FaShieldAlt: <FaShieldAlt />,
    FaUsers: <FaUsers />,
    FaMobileAlt: <FaMobileAlt />,
    FaPaintBrush: <FaPaintBrush />,
    FaDatabase: <FaDatabase />,
    FaChartBar: <FaChartBar />,
    FaChartPie: <FaChartPie />,
    FaServer: <FaServer />,
    FaSearch: <FaSearch />,
    FaUserCheck: <FaUserCheck />,
    FaUserSecret: <FaUserSecret />,
    FaNetworkWired: <FaNetworkWired />,
    FaTools: <FaTools />,
    FaCloud: <FaCloud />,
    FaStore: <FaStore />,
    FaChartLine: <FaChartLine />,
    FaMoneyBillWave: <FaMoneyBillWave />
};

function YangilikModal({ newsId, onClose }) {
    const newsItem = newsData.find((item) => item.id === parseInt(newsId));
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isClosing, setIsClosing] = useState(false);

    const images = newsItem?.secondaryImages && newsItem.secondaryImages.length > 0
        ? newsItem.secondaryImages
        : (newsItem ? [newsItem.image] : []);

    const nextSlide = () => {
        if (!images.length) return;
        setCurrentSlide((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    // Auto slide
    useEffect(() => {
        if (!newsItem) return;
        const interval = setInterval(() => {
            nextSlide();
        }, 3000);
        return () => clearInterval(interval);
    }, [currentSlide, newsItem]);

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            onClose();
        }, 300);
    };

    if (!newsItem) return null;

    return (
        <div className={`yangilik-modal-overlay ${isClosing ? 'fade-out' : 'fade-in'}`} onClick={handleClose}>
            <div
                className={`yangilik-modal-content ${isClosing ? 'scale-out' : 'scale-in'}`}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="yangilik-modal-header">
                    <h2>{newsItem.title}</h2>
                    <button className="close-btn" onClick={handleClose}>
                        <FaTimes />
                    </button>
                </div>

                {/* Body - Scrollable */}
                <div className="yangilik-modal-body">
                    {/* Slider */}
                    <div className="yangilik-slider simple-slider">
                        <div className="slider-wrapper">
                            <img src={images[currentSlide]} alt="Slide" className="slider-image" />
                            <div className="slider-dots">
                                {images.map((_, idx) => (
                                    <span
                                        key={idx}
                                        className={`dot ${currentSlide === idx ? "active" : ""}`}
                                        onClick={() => setCurrentSlide(idx)}
                                    ></span>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Content Sections */}
                    <div className="yangilik-batafsil-card">
                        {newsItem.sections ? (
                            newsItem.sections.map((section, index) => (
                                <div key={index} className="batafsil-section">
                                    <div className="section-icon">
                                        {iconMap[section.icon] || <FaLightbulb />}
                                    </div>
                                    <div className="section-content">
                                        <h3>{section.title}</h3>
                                        <p>{section.text}</p>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="yangilik-matn">{newsItem.fullText || newsItem.desc}</p>
                        )}

                        <p className="batafsil-footer-note">
                            Bizning platformamizda ushbu mavzu bo'yicha maxsus kurslar ham mavjud.
                            Batafsil o'rganish uchun tegishli bo'limlarga o'tishingiz mumkin.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default YangilikModal;
